/**
 * 반응형 디자인 브레이크포인트 정의
 */

export const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1440px',
} as const;

export const mediaQueries = {
  mobile: `@media (min-width: ${breakpoints.mobile})`,
  tablet: `@media (min-width: ${breakpoints.tablet})`,
  desktop: `@media (min-width: ${breakpoints.desktop})`,
  wide: `@media (min-width: ${breakpoints.wide})`,

  // max-width 기준
  maxMobile: `@media (max-width: ${breakpoints.tablet})`,
  maxTablet: `@media (max-width: ${breakpoints.desktop})`,
  maxDesktop: `@media (max-width: ${breakpoints.wide})`,
} as const;

export type Breakpoint = keyof typeof breakpoints;
